import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Listado, ListadoListResponse, ListadoOpcion } from './listado.model';

@Injectable({ providedIn: 'root' })
export class GestionListadosService {

  private readonly API_URL: string = environment.API_URL;

  constructor(private http: HttpClient) {}

  list(opts: { page?: number; size?: number; search?: string; activo?: boolean | null }): Observable<ListadoListResponse> {
    let params = new HttpParams()
      .set('page', String(opts.page ?? 0))
      .set('size', String(opts.size ?? 50));
    if (opts.search && opts.search.trim()) params = params.set('search', opts.search.trim());
    if (opts.activo != null) params = params.set('activo', String(opts.activo));
    return this.http.get<ListadoListResponse>(`${this.API_URL}/listado-config/list`, { params });
  }

  getById(id: number): Observable<Listado> {
    return this.http.get<Listado>(`${this.API_URL}/listado-config/${id}`);
  }

  create(payload: Partial<Listado>): Observable<any> {
    return this.http.post(`${this.API_URL}/listado-config/create`, payload);
  }

  update(id: number, payload: Partial<Listado>): Observable<any> {
    return this.http.post(`${this.API_URL}/listado-config/update/${id}`, payload);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.API_URL}/listado-config/${id}`);
  }

  addOpcion(listadoId: number, payload: Partial<ListadoOpcion>): Observable<any> {
    return this.http.post(`${this.API_URL}/listado-config/${listadoId}/opcion`, payload);
  }

  updateOpcion(opcionId: number, payload: Partial<ListadoOpcion>): Observable<any> {
    return this.http.post(`${this.API_URL}/listado-config/opcion/${opcionId}/update`, payload);
  }

  deleteOpcion(opcionId: number): Observable<any> {
    return this.http.delete(`${this.API_URL}/listado-config/opcion/${opcionId}`);
  }

  toggleOpcion(opcionId: number): Observable<any> {
    return this.http.post(`${this.API_URL}/listado-config/opcion/${opcionId}/toggle`, {});
  }

  moveOpcion(opcionId: number, direction: 'up' | 'down'): Observable<any> {
    const params = new HttpParams().set('direction', direction);
    return this.http.post(`${this.API_URL}/listado-config/opcion/${opcionId}/move`, {}, { params });
  }
}
